/**
 * Guard for the Farm View page-level keyboard shortcuts (arrow keys / Escape
 * to move or clear the field selection, A for Advanced mode, N for NDVI).
 *
 * They must not fire while the user is typing in a form control, or while a
 * Bootstrap modal is open (e.g. Report event / Delete event from the Field
 * details tab): the modal owns the keyboard then. Without this, Escape both
 * closed the modal and deselected the field (unmounting the modal mid-close),
 * and the arrow keys switched fields underneath it.
 */

const EDITABLE_TAGS = ['INPUT', 'TEXTAREA', 'SELECT'];

const isEditableTarget = (target) =>
  EDITABLE_TAGS.includes(target?.tagName) || Boolean(target?.isContentEditable);

// Bootstrap adds `modal-open` to <body> while any modal is shown.
const isModalOpen = (doc) =>
  Boolean(doc?.body?.classList?.contains('modal-open'));

const shouldIgnoreShortcut = (event, doc) =>
  isEditableTarget(event?.target) || isModalOpen(doc);

module.exports = { shouldIgnoreShortcut };
